// src/router/containers.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['operacional_prana', 'colaborador_satya', 'cliente_containers']

const containersBreadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Containers',
        to: 'Containers'
    }
]

export default [
    {
        path: '/containers',
        name: 'Containers',
        component: () => import('@/views/Containers/ContainerListPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Containers',
            breadcrumb: containersBreadCrumb
        },
    },
];
